import { ProductMake } from "@/types";
import { ProductModel } from "@/types/product-model";
import { getData, postData, putData } from "./axios-service";

function modelMapper(inputProduct: any): ProductModel {
    return {
        id: inputProduct.id,
        productMake: inputProduct.productMake,
        model: inputProduct.model,
    };
}

export function modelMapperArray(inputArray: any[]): ProductModel[] {
    return inputArray.map(modelMapper);
}

export async function fetchProductModels(): Promise<ProductModel[]> {
    const productModels = await getData<ProductModel[]>("/product-models");
    return modelMapperArray(productModels ?? []);
}

export async function fetchFilteredProductModels(productMake: ProductMake): Promise<ProductModel[]> {
    let url = "/product-models?product_make=" + encodeURIComponent(productMake);
    const productModels = await getData<ProductModel[]>(url);
    return modelMapperArray(productModels ?? []);
}

export async function fetchProductModelById(id: string): Promise<ProductModel> {
    const productModel = await getData<ProductModel>(`/product-models/${id}`);
    return modelMapper(productModel);
}

export async function postProductModel(productModel: ProductModel): Promise<ProductModel> {
    const response = await postData("/product-models", productModel);
    return modelMapper(response);
}

export function putProductModel(productModel: ProductModel): Promise<any> {
    return  putData(`/product-models/${productModel.id}`, productModel);
}